import { render, staticRenderFns } from "./InvoiceTypeCreateEdit.vue?vue&type=template&id=24843c48&scoped=true&"
import script from "./InvoiceTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./InvoiceTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTypeCreateEdit.vue?vue&type=style&index=0&id=24843c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24843c48",
  null
  
)

export default component.exports